import { Dispatch, SetStateAction, createContext } from 'react';

import { ExecutionHistory } from 'pages/AutomationEngine/types';
import { FilterRecord } from 'pages/AutomationEngine/ExecutionFrameWork/ExecutionFilterPill/types';

export type ExecutionToShow = { automationId: string; executionId: string };
export type AutomationsStartedList = {
  automationId: string;
  name: string;
  count: number;
};

export const MAX_DEBUGGERS_TO_START = 10;

export type ExecutionHistoryContextType = {
  historyId: string | null;
  orderedExecutionHistory: ExecutionHistory[];
  selectedHistoryStep: ExecutionHistory | null;
  showHistorySideBar: boolean;
  setSelectedHistoryStep: Dispatch<SetStateAction<ExecutionHistory | null>>;
  setHistoryId: Dispatch<SetStateAction<string | null>>;
  setShowHistorySideBar: Dispatch<SetStateAction<boolean>>;
  setOrderedExecutionHistory: Dispatch<SetStateAction<any[]>>;
  getSelectedHistoryStep: () => ExecutionHistory | undefined;
  executionMode: boolean;
  setExecutionMode: (executionMode: boolean) => void;
  selectedExecution: null | any;
  setSelectedExecution: (execution: null | any) => void;
  executionWarning: string;
  setExecutionWarning: (waring: string) => void;
  isHistoryFetching: number;
  filters: FilterRecord;
  setFilters: Dispatch<SetStateAction<FilterRecord>>;
  showExecutionsPanel: boolean;
  setShowExecutionsPanel: Dispatch<SetStateAction<boolean>>;
  runningDebugAction: string | null;
  setRunningDebugAction: Dispatch<SetStateAction<string | null>>;
  debugWindowsToOpen: number;
  setDebugWindowsToOpen: Dispatch<SetStateAction<number>>;
  showDebugToStartModal: boolean;
  setShowDebugToStartModal: Dispatch<SetStateAction<boolean>>;
  debugExecutionsList: ExecutionToShow[];
  setDebugExecutionsList: Dispatch<SetStateAction<ExecutionToShow[]>>;
  debugAutomationsList: AutomationsStartedList[];
  setDebugAutomationsList: Dispatch<SetStateAction<AutomationsStartedList[]>>;
  rerunModalStepId: null | string;
  setRerunModalStepId: Dispatch<SetStateAction<null | string>>;
  canEditAutomation: boolean;
};

export const defaultContext: ExecutionHistoryContextType = {
  historyId: null,
  orderedExecutionHistory: [],
  selectedHistoryStep: null,
  showHistorySideBar: false,
  setSelectedHistoryStep: () => {},
  setHistoryId: () => {},
  setShowHistorySideBar: () => {},
  setOrderedExecutionHistory: () => {},
  getSelectedHistoryStep: (): ExecutionHistory | undefined => {
    return undefined;
  },
  executionMode: false,
  setExecutionMode: () => {},
  selectedExecution: null,
  setSelectedExecution: () => {},
  executionWarning: '',
  setExecutionWarning: () => {},
  isHistoryFetching: 0,
  filters: {
    trigger_id: undefined,
    status: undefined,
    record_id: undefined,
  },
  setFilters: () => {},
  showExecutionsPanel: true,
  setShowExecutionsPanel: () => {},
  runningDebugAction: null,
  setRunningDebugAction: () => {},
  debugWindowsToOpen: 1,
  setDebugWindowsToOpen: () => {},
  showDebugToStartModal: false,
  setShowDebugToStartModal: () => {},
  debugExecutionsList: [],
  setDebugExecutionsList: () => {},
  debugAutomationsList: [],
  setDebugAutomationsList: () => {},
  rerunModalStepId: null,
  setRerunModalStepId: () => {},
  canEditAutomation: false,
};

export const ExecutionHistoryContext =
  createContext<ExecutionHistoryContextType>(defaultContext);
